"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconShedFilled = function IconShedFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return _react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, _react.default.createElement("title", null, "Shed"), _react.default.createElement("path", {
    d: "M27.5 23H22.5C21.6716 23 21 23.6716 21 24.5C21 25.3284 21.6716 26 22.5 26H27.5C28.3284 26 29 25.3284 29 24.5C29 23.6716 28.3284 23 27.5 23Z",
    fill: color
  }), _react.default.createElement("path", {
    d: "M27.5 29H22.5C21.6716 29 21 29.6716 21 30.5C21 31.3284 21.6716 32 22.5 32H27.5C28.3284 32 29 31.3284 29 30.5C29 29.6716 28.3284 29 27.5 29Z",
    fill: color
  }), _react.default.createElement("path", {
    d: "M27.5 35H22.5C21.6716 35 21 35.6716 21 36.5C21 37.3284 21.6716 38 22.5 38H27.5C28.3284 38 29 37.3284 29 36.5C29 35.6716 28.3284 35 27.5 35Z",
    fill: color
  }), _react.default.createElement("path", {
    d: "M27.5 41H22.5C21.6716 41 21 41.6716 21 42.5C21 43.3284 21.6716 44 22.5 44H27.5C28.3284 44 29 43.3284 29 42.5C29 41.6716 28.3284 41 27.5 41Z",
    fill: color
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.56 7.19L13.19 14.85C13.1214 14.8963 13.0655 14.959 13.0271 15.0323C12.9887 15.1056 12.9691 15.1873 12.97 15.27V43.5C12.97 43.6326 13.0227 43.7598 13.1164 43.8535C13.2102 43.9473 13.3374 44 13.47 44H18.47C18.6026 44 18.7298 43.9473 18.8236 43.8535C18.9173 43.7598 18.97 43.6326 18.97 43.5V21.5C18.97 21.3674 19.0227 21.2402 19.1165 21.1464C19.2102 21.0527 19.3374 21 19.47 21H30.47C30.6026 21 30.7298 21.0527 30.8236 21.1464C30.9173 21.2402 30.97 21.3674 30.97 21.5V43.5C30.97 43.6326 31.0227 43.7598 31.1165 43.8535C31.2102 43.9473 31.3374 44 31.47 44H36.47C36.6026 44 36.7298 43.9473 36.8236 43.8535C36.9173 43.7598 36.97 43.6326 36.97 43.5V15.5C36.9711 15.4186 36.9515 15.3383 36.913 15.2666C36.8745 15.1948 36.8184 15.1341 36.75 15.09L25.12 7.19C25.0384 7.13139 24.9405 7.09987 24.84 7.09987C24.7395 7.09987 24.6416 7.13139 24.56 7.19Z",
    fill: color
  }));
};

IconShedFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconShedFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconShedFilled;
exports.default = _default;